<div class="card-footer {{ andClass }}" [class.transparent]="transparent">
  <ng-content></ng-content>
</div>
